import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { XCircle } from "lucide-react";

export default function BillingCancel() {
  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center p-6" data-testid="billing-cancel-page">
      <div className="max-w-lg w-full bg-white border border-zinc-200 rounded-sm p-10 text-center">
        <XCircle size={40} className="text-zinc-500 mx-auto mb-4"/>
        <h1 className="font-display text-2xl font-medium tracking-tight mb-2">Paiement annulé</h1>
        <p className="text-zinc-600 mb-6">Aucun montant n'a été prélevé. Vous pouvez réessayer à tout moment.</p>
        <div className="flex items-center justify-center gap-3">
          <Link to="/#pricing"><Button className="rounded-sm bg-black text-white hover:bg-zinc-800">Voir les plans</Button></Link>
          <Link to="/app/dashboard"><Button variant="outline" className="rounded-sm">Tableau de bord</Button></Link>
        </div>
      </div>
    </div>
  );
}
